var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('new-widget-dialog',{ref:"newWidgetDialog",attrs:{"hidden-widgets":_vm.hiddenWidgets},on:{"addWidget":_vm.addWidget}}),_c('widget-form-dialog',{ref:"widgetFormDialog",on:{"submit":_vm.formDialogSubmitted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }